'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Star, Check } from 'lucide-react';
import { toast } from 'sonner';

const CANDIDATES = [
{ id: 'cand-001', name: 'Biscuit', breed: 'Golden Retriever', owner: 'Sarah Reynolds', paws: 2847, score: 98, photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1acf8933a-1772134254500.png", photoAlt: 'Golden retriever Biscuit smiling in park', selected: true },
{ id: 'cand-002', name: 'Cosmo', breed: 'Australian Shepherd', owner: 'Tyler Nguyen', paws: 2203, score: 91, photo: "https://images.unsplash.com/photo-1607695201913-f845e53bbabe", photoAlt: 'Australian shepherd Cosmo with merle coat', selected: false },
{ id: 'cand-003', name: 'Luna', breed: 'Samoyed', owner: 'Priya Sharma', paws: 1891, score: 87, photo: "https://images.unsplash.com/photo-1570888233685-955514fce7cf", photoAlt: 'White Samoyed Luna with fluffy coat smiling', selected: false }];


export default function AdminDogOfTheDay() {
  const [candidates, setCandidates] = useState(CANDIDATES);
  const [saving, setSaving] = useState(false);

  const selectDog = (id: string) => {
    setCandidates((c) => c.map((d) => ({ ...d, selected: d.id === id })));
  };

  const handlePublish = async () => {
    setSaving(true);
    await new Promise((r) => setTimeout(r, 900));
    setSaving(false);
    toast.success('Dog of the Day published! Email notifications sent.');
  };

  const current = candidates.find((c) => c.selected);

  return (
    <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">
      {/* Header */}
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Star size={16} className="text-accent" />
          <h3 className="font-700 text-sm text-foreground">Dog of the Day</h3>
        </div>
        <span className="text-xs text-muted-foreground">June 22, 2026</span>
      </div>

      {/* Current winner */}
      {current &&
      <div className="p-5 border-b border-border">
          <p className="text-xs font-600 text-muted-foreground uppercase tracking-wider mb-3">Today's Winner</p>
          <div className="flex items-center gap-3">
            <div className="relative w-16 h-16 rounded-xl overflow-hidden bg-muted shrink-0">
              <AppImage src={current.photo} alt={current.photoAlt} width={64} height={64} className="object-cover w-full h-full" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-800 text-base text-foreground">{current.name}</p>
              <p className="text-xs text-muted-foreground">{current.breed}</p>
              <p className="text-xs text-muted-foreground">by {current.owner}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="text-2xl font-800 text-accent stat-badge">{current.score}</p>
              <p className="text-xs text-muted-foreground">score</p>
            </div>
          </div>
        </div>
      }

      {/* Candidates */}
      <div className="p-5">
        <p className="text-xs font-600 text-muted-foreground uppercase tracking-wider mb-3">Top Candidates</p>
        <div className="space-y-2">
          {candidates.map((c) =>
          <button
            key={c.id}
            onClick={() => selectDog(c.id)}
            className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-all text-left
                ${c.selected ? 'border-primary bg-secondary' : 'border-border hover:bg-muted'}`}>
            
              <div className="w-10 h-10 rounded-lg overflow-hidden bg-muted shrink-0">
                <AppImage src={c.photo} alt={c.photoAlt} width={40} height={40} className="object-cover w-full h-full" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-700 text-sm text-foreground">{c.name}</p>
                <p className="text-xs text-muted-foreground">🐾 {c.paws.toLocaleString()} paws</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-sm font-700 text-foreground stat-badge">{c.score}</span>
                {c.selected && <Check size={14} className="text-primary" />}
              </div>
            </button>
          )}
        </div>

        <button
          onClick={handlePublish}
          disabled={saving}
          className="paw-btn mt-4 w-full flex items-center justify-center gap-2 py-2.5 bg-primary text-primary-foreground rounded-xl text-sm font-700 hover:bg-secondary-foreground transition-all disabled:opacity-60">
          
          {saving ?
          <><span className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />Publishing...</> :

          <><Star size={15} />Publish Dog of the Day</>
          }
        </button>
      </div>
    </div>);

}